import axios from "axios";
import { API_BASE as SBIN_API_BASE } from "./base";

const API = SBIN_API_BASE;

const clientAuthHeaders = (token) => ({
  "Content-Type": "application/json",
  ...(token ? { Authorization: `Bearer ${token}` } : {}),
});

export async function getOnlineServices(salonId, token) {
  const res = await axios.get(
    `${API}/client-portal/salons/${salonId}/online-services`,
    { headers: clientAuthHeaders(token) }
  );
  return res.data;
}

const buildQueryParams = (params = {}) => {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item === undefined || item === null || item === "") return;
        searchParams.append(key, String(item));
      });
      return;
    }
    searchParams.append(key, String(value));
  });
  return searchParams;
};

export async function getOnlineStaff(salonId, params, token) {
  const res = await axios.get(
    `${API}/client-portal/salons/${salonId}/online-staff`,
    {
      params: buildQueryParams(params),
      headers: clientAuthHeaders(token),
    }
  );
  return res.data;
}

export async function getAvailability(salonId, params, token) {
  const res = await axios.get(
    `${API}/client-portal/salons/${salonId}/availability`,
    {
      params: buildQueryParams(params),
      headers: clientAuthHeaders(token),
    }
  );
  return res.data;
}

export async function bookAppointment(payload, token) {
  const res = await axios.post(`${API}/client-portal/book`, payload, {
    headers: clientAuthHeaders(token),
  });
  return res.data;
}

export async function getMyAppointments(range, token) {
  const res = await axios.get(`${API}/client-portal/my-appointments`, {
    params: { range },
    headers: clientAuthHeaders(token),
  });
  return res.data;
}

export async function getRescheduleOptions(appointmentId, token) {
  const res = await axios.get(
    `${API}/client-portal/appointments/${appointmentId}/reschedule-options`,
    { headers: clientAuthHeaders(token) }
  );
  return res.data;
}

export async function rescheduleAppointment(appointmentId, payload, token) {
  const res = await axios.post(
    `${API}/client-portal/appointments/${appointmentId}/reschedule`,
    payload,
    { headers: clientAuthHeaders(token) }
  );
  return res.data;
}

export async function cancelAppointment(appointmentId, token) {
  const res = await axios.post(
    `${API}/client-portal/appointments/${appointmentId}/cancel`,
    {},
    { headers: clientAuthHeaders(token) }
  );
  return res.data;
}

export async function uploadAppointmentAttachment(appointmentId, file, token) {
  const formData = new FormData();
  formData.append("file", file);
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const res = await axios.post(
    `${API}/client-portal/appointments/${appointmentId}/attachment`,
    formData,
    { headers }
  );
  return res.data;
}
